import React from 'react';

import { SVGComponentProps } from './svg.types';
//Icon specifically for Forms, hence fill and size not updated
const SmileyPlainSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <circle cx="16" cy="16" r="15.5556" fill="white" stroke="#878A92" strokeWidth="0.888889" />
        <ellipse cx="10.6667" cy="11.5556" rx="1.77778" ry="3.55556" fill="#C4C4C4" />
        <ellipse cx="20.4445" cy="11.5556" rx="1.77778" ry="3.55556" fill="#C4C4C4" />
        <path
          d="M8 19.8826C8 21.446 8.84286 22.9453 10.3431 24.0508C11.8434 25.1563 13.8783 25.7773 16 25.7773C18.1217 25.7773 20.1566 25.1563 21.6569 24.0508C23.1571 22.9453 24 21.446 24 19.8826L16 19.8826L8 19.8826Z"
          fill="#C4C4C4"
        />
      </svg>
    </span>
  );
};

export default SmileyPlainSVG;
